// extracted by mini-css-extract-plugin
module.exports = {"paragraphContainer":"styles__paragraphContainer___vAvne"};